"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IneligibleForDriveawayModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var portal_core_1 = require("@ferry/portal-core");
var BaseAlertModal_1 = require("../../components/modals/BaseAlertModal");
var journey_services_1 = require("@athena-portal/journey-services");
var IneligibleForDriveawayModalWidget = /** @class */ (function (_super) {
    __extends(IneligibleForDriveawayModalWidget, _super);
    function IneligibleForDriveawayModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showModal: true,
        };
        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }
    IneligibleForDriveawayModalWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(BaseAlertModal_1.BaseAlertModal, { modalTitle: "Sorry...", modalBody: this.renderModalBody(), showModal: this.state.showModal, onClose: this.closeModal }));
    };
    IneligibleForDriveawayModalWidget.prototype.renderModalBody = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["We're unable to process your ", (0, jsx_runtime_1.jsx)("strong", { children: "5-Day Drive Away cover" }), " online."] }), (0, jsx_runtime_1.jsx)("p", { className: "mt-0", children: "Please call us on:" }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("a", { href: this.toTelHref(portal_core_1.resourcesHelper.DRIVE_PHONE_NUMBER || ""), id: "driveawayCallCenterNumber", "aria-label": "Phone number ".concat(portal_core_1.resourcesHelper.DRIVE_PHONE_NUMBER), className: "text-decoration-underline font-weight-bold", children: portal_core_1.resourcesHelper.DRIVE_PHONE_NUMBER }) }), (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: "Monday to Friday: 8am-8pm" }), (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: "Saturday & bank holidays: 9am-5pm" })] }));
    };
    IneligibleForDriveawayModalWidget.prototype.toTelHref = function (raw) {
        var digits = raw.trim();
        return "tel:+44 ".concat(digits);
    };
    IneligibleForDriveawayModalWidget.prototype.closeModal = function () {
        this.setState({ showModal: false });
        // resetting the field used for rendering in case someone tries to resubmit the form
        journey_services_1.ObjectManipulator.setField("uistate.directUserToCallCentre", this.props.interaction, null);
    };
    return IneligibleForDriveawayModalWidget;
}(plugin_journey_1.WidgetBase));
exports.IneligibleForDriveawayModalWidget = IneligibleForDriveawayModalWidget;
//# sourceMappingURL=IneligibleForDriveawayModalWidget.js.map